"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeAndPrecisionOptions = getTimeAndPrecisionOptions;
exports.convertPredefinedDateToStartEndDateTime = convertPredefinedDateToStartEndDateTime;
exports.isDateRangeLargerThenMaxTimeSpanMinutes = isDateRangeLargerThenMaxTimeSpanMinutes;
exports.isEndDateBeforeStartDate = isEndDateBeforeStartDate;
exports.getTimeRangeSelectorShiftOptions = getTimeRangeSelectorShiftOptions;
exports.getTimeRangeSelectorShiftDefault = getTimeRangeSelectorShiftDefault;

var _moment = _interopRequireDefault(require("moment"));

var _brockDateTime = require("brock-date-time");

var _TimeRangeSelectorConstants = require("./TimeRangeSelectorConstants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line complexity, max-params


function getTimeAndPrecisionOptions(predefinedDateRangeOptions, timeAndPrecisionOptionsFromProps, previouslyUsedRanges, labels) {
  var timeAndPrecisionOptions = Object.keys(_TimeRangeSelectorConstants.timeAndPrecisionTypes).map(function (optionName) {
    return {
      description: labels[optionName],
      id: optionName
    };
  });

  if (!(predefinedDateRangeOptions !== null && predefinedDateRangeOptions !== void 0 && predefinedDateRangeOptions.length)) {
    timeAndPrecisionOptions = timeAndPrecisionOptions.filter(function (x) {
      return x.id !== _TimeRangeSelectorConstants.timeAndPrecisionTypes.predefined;
    });
  }

  if (timeAndPrecisionOptionsFromProps !== null && timeAndPrecisionOptionsFromProps !== void 0 && timeAndPrecisionOptionsFromProps.length) {
    timeAndPrecisionOptions = timeAndPrecisionOptions.filter(function (x) {
      return timeAndPrecisionOptionsFromProps.includes(x.id);
    });
  }

  if (!(previouslyUsedRanges !== null && previouslyUsedRanges !== void 0 && previouslyUsedRanges.length) || timeAndPrecisionOptionsFromProps.length && !timeAndPrecisionOptionsFromProps.includes(_TimeRangeSelectorConstants.timeAndPrecisionTypes.fixed)) {
    timeAndPrecisionOptions = timeAndPrecisionOptions.filter(function (x) {
      return x.id !== _TimeRangeSelectorConstants.timeAndPrecisionTypes.usePrevious;
    });
  }

  return timeAndPrecisionOptions;
}

function convertPredefinedDateToStartEndDateTime(predefinedDate) {
  var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date();
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _brockDateTime.DateTimeFormats.DATETIME;
  var predefinedType = predefinedDate.predefinedType,
      predefinedValue = predefinedDate.predefinedValue,
      predefinedLength = predefinedDate.predefinedLength;
  var start = (0, _moment["default"])(currentDate).add(predefinedValue, predefinedType).startOf(predefinedType).format(format);
  return {
    start: start,
    end: (0, _moment["default"])(start).add(predefinedLength, predefinedType).startOf(predefinedType).format(format)
  };
}

function isDateRangeLargerThenMaxTimeSpanMinutes(rangeStartDateTime, rangeEndDateTime, maxTimeSpanInMinutes) {
  if (!maxTimeSpanInMinutes) {
    return false;
  }

  var differenceInMinutes = _brockDateTime.MomentUtilities.minutesDifference(rangeStartDateTime, rangeEndDateTime);

  return maxTimeSpanInMinutes < differenceInMinutes;
}

function isEndDateBeforeStartDate(rangeStartDateTime, rangeEndDateTime) {
  return _brockDateTime.MomentUtilities.dateIsBefore(rangeEndDateTime, rangeStartDateTime);
}

function getTimeRangeSelectorShiftOptions(timeRangeSelectorShiftOptionsFromProps, labels) {
  var timeRangeSelectorShiftOptions = Object.keys(_TimeRangeSelectorConstants.timeRangeSelectorShiftTypes).map(function (optionName) {
    return {
      textField: labels[optionName],
      valueField: optionName
    };
  });

  if (timeRangeSelectorShiftOptionsFromProps !== null && timeRangeSelectorShiftOptionsFromProps !== void 0 && timeRangeSelectorShiftOptionsFromProps.length) {
    timeRangeSelectorShiftOptions = timeRangeSelectorShiftOptions.filter(function (x) {
      return timeRangeSelectorShiftOptionsFromProps.includes(x.valueField);
    });
  }

  return timeRangeSelectorShiftOptions;
}

function getTimeRangeSelectorShiftDefault(shiftTypeDefault, shiftRangeOptions) {
  var _shiftRangeOptions$fi;

  return (_shiftRangeOptions$fi = shiftRangeOptions.find(function (x) {
    return x.valueField === shiftTypeDefault;
  })) !== null && _shiftRangeOptions$fi !== void 0 ? _shiftRangeOptions$fi : shiftRangeOptions[0];
}